// extracted by mini-css-extract-plugin
export default {"swiperWrapper":"tbDZNV","prev":"YByluJ","next":"QFb3d9"};